require('./subcategoryFilter.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');

// @ components
const OKSelect = require('components/commons/OKSelect/OKSelect');

// @ helpers
const { formatText, FormattedText } = require('core/i18n').i18n;

// @constants
const { getSubcategoryOptions } = require('constants/categories');

class SubcategoryFilter extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            subcategory: props.immFilter.getIn(['subcategory', 'subcategory'])
        }
        this.handleSubcategoryChange = this.handleSubcategoryChange.bind(this);
    }

    handleSubcategoryChange(concept) {
        this.setState({
            subcategory: concept.value
        });
        this.props.onSubcategoryChange(concept.value);
    }

    render() {
        const { category } = this.props;
        const all = formatText('filters-all');
        const options = [{
            label: `${ all.charAt(0).toUpperCase() }${ all.slice(1) }`,
            value: 'all'
        }, ...getSubcategoryOptions(category)]

        return (
            <section className="subcategory-filter">
                <header className="subcategory-filter__title">
                    <FormattedText value="subcategoryFilter-title" />
                </header>
                <OKSelect
                    name="movement-type-filter-dropdown"
                    onChange={this.handleSubcategoryChange}
                    value={this.state.subcategory}
                    options={options}
                    searchable={false}
                    clearable={false}
                    openUp={true}
                />
            </section>
        );
    }
}

SubcategoryFilter.propTypes = {
    immFilter: PropTypes.object.isRequired,
    category: PropTypes.string.isRequired,
    onSubcategoryChange: PropTypes.func.isRequired
};

module.exports = SubcategoryFilter;
